// extracted by mini-css-extract-plugin
export default {"white":"dashboard_white__qmr5p"};